import { SET_GAME_STARTED } from "../actions/types";

const DEFAULT_SETTINGS = {
    gameStarted: false
}

const settingsReducer = (state = DEFAULT_SETTINGS, action) => {

    switch (action.type) {
        case SET_GAME_STARTED:
            return {
                ...state,
                gameStarted: action.gameStarted
            }
        default:
            return state;
    }
}

export default settingsReducer;